<form [formGroup]="createForm" (ngSubmit)="onSubmit()" class="form-validation">

  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{ modalTitle }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">

      <!-- company -->
      <div class="form-group col-sm-12">
        <label for="first-name">Company</label>
        <input type="text" class="form-control" formControlName="company"
          [ngClass]="formErrorClass(createForm.controls.company, createFormSubmitted)">
        <span class="text-danger"
          *ngIf="(createForm.controls.company?.touched || createFormSubmitted) && createForm.controls.company?.errors?.required">
          This field is required.
        </span>
      </div>

      <!-- Email -->
      <div class="form-group col-sm-12">
        <label for="first-name">Email</label>
        <input type="text" class="form-control" formControlName="email"
          [ngClass]="formErrorClass(createForm.controls.email, createFormSubmitted)">
        <span class="text-danger"
          *ngIf="(createForm.controls.email?.touched || createFormSubmitted) && createForm.controls.email?.errors?.required">
          This field is required.
        </span>
      </div>


      <!-- Headquaters -->
      <div class="form-group col-sm-12">
        <label for="first-name">Headquaters</label>
        <input type="text" class="form-control" formControlName="hqo"
          [ngClass]="formErrorClass(createForm.controls.hqo, createFormSubmitted)">
        <span class="text-danger"
          *ngIf="(createForm.controls.hqo?.touched || createFormSubmitted) && createForm.controls.hqo?.errors?.required">
          This field is required.
        </span>
      </div>


      <!-- phone -->
      <div class="form-group col-sm-12">
        <label for="first-name">Phone</label>
        <input type="text" class="form-control" formControlName="phone"
          [ngClass]="formErrorClass(createForm.controls.phone, createFormSubmitted)">
        <span class="text-danger"
          *ngIf="(createForm.controls.phone?.touched || createFormSubmitted) && createForm.controls.phone?.errors?.required">
          This field is required.
        </span>
      </div>


      <!-- First Name -->
      <div class="form-group col-sm-12">
        <label for="first-name">First Name</label>
        <input type="text" class="form-control" formControlName="fname"
          [ngClass]="formErrorClass(createForm.controls.fname, createFormSubmitted)">
        <span class="text-danger"
          *ngIf="(createForm.controls.fname?.touched || createFormSubmitted) && createForm.controls.fname?.errors?.required">
          This field is required.
        </span>
      </div>


      <!-- Password -->
      <div class="form-group col-sm-12">
        <label for="first-name">Password</label>
        <input type="text" class="form-control" formControlName="password"
          [ngClass]="formErrorClass(createForm.controls.password, createFormSubmitted)">
        <span class="text-danger"
          *ngIf="(createForm.controls.password?.touched || createFormSubmitted) && createForm.controls.password?.errors?.required">
          This field is required.
        </span>
      </div>


      <!-- Expiry Date -->
      <div class="form-group col-sm-12">
        <label for="first-name">Expiry Date</label>
        <input type="date" class="form-control" formControlName="exp_date"
          [ngClass]="formErrorClass(createForm.controls.exp_date, createFormSubmitted)">
        <span class="text-danger"
          *ngIf="(createForm.controls.exp_date?.touched || createFormSubmitted) && createForm.controls.exp_date?.errors?.required">
          This field is required.
        </span>
      </div>


      <!-- Change Language -->
      <div class="form-group col-sm-12">
        <label for="first-name">Change Language</label>
        <!-- <ng-multiselect-dropdown
          [class.is-invalid]="createForm.controls?.change_lang?.errors?.required && createForm.controls?.change_lang?.touched"
          formControlName="change_lang" [data]="langOptions" [settings]="langDropdownSettings"
          [ngClass]="formErrorClass(createForm.controls.change_lang, createFormSubmitted)"> </ng-multiselect-dropdown> -->

          <select class="form-control" formControlName="change_lang"
          [ngClass]="formErrorClass(createForm.controls.change_lang, createFormSubmitted)">
            <option value="english">English</option>
            <option value="italian">Italian</option>
          </select>

        <span class="text-danger"
          *ngIf="(createForm.controls.change_lang?.touched || createFormSubmitted) && createForm.controls.change_lang?.errors?.required">
          This field is required.
        </span>
      </div>


      <!-- Business Contact -->
      <div class="form-group col-sm-12">
        <label for="first-name">Business Contact</label>
        <input type="text" class="form-control" formControlName="busi_contact"
          [ngClass]="formErrorClass(createForm.controls.busi_contact, createFormSubmitted)">
        <span class="text-danger"
          *ngIf="(createForm.controls.busi_contact?.touched || createFormSubmitted) && createForm.controls.busi_contact?.errors?.required">
          This field is required.
        </span>
      </div>

      <!-- Commission -->
      <div class="form-group col-sm-12">
        <label for="first-name">commission</label>
        <input type="text" class="form-control" formControlName="commission"
          [ngClass]="formErrorClass(createForm.controls.commission, createFormSubmitted)">
        <span class="text-danger"
          *ngIf="(createForm.controls.commission?.touched || createFormSubmitted) && createForm.controls.commission?.errors?.required">
          This field is required.
        </span>
      </div>

      <!-- Change Language -->
      <div class="form-group col-sm-12">
        <label for="first-name">Select Package</label>
          <select class="form-control" formControlName="package"
          [ngClass]="formErrorClass(createForm.controls.change_lang, createFormSubmitted)">
            <option *ngFor="let pakage of packageList" value="{{pakage?.id}}">{{ pakage?.package_name }}</option>
          </select>

        <span class="text-danger"
          *ngIf="(createForm.controls.change_lang?.touched || createFormSubmitted) && createForm.controls.change_lang?.errors?.required">
          This field is required.
        </span>
      </div>      

      <div class="form-group col-sm-6">
        <button type="submit" class="btn btn-primary">Submit</button>
      </div>


    </div>
  </div>


</form>